import {getRuntimeConfig} from 'src/pages/api/config.api';

import {TERM_PAGE_SUB_PATHS} from '../constants';

export const fetchPageContentFromCMS = async ({
    locale,
    slug,
    isPreviewEnabled = false,
}: {
    locale: string;
    slug: string;
    isPreviewEnabled?: boolean;
}) => {
    const isServer = typeof window === 'undefined';

    if (!TERM_PAGE_SUB_PATHS.includes(slug)) {
        return {
            notFound: true,
        };
    }

    // eslint-disable-next-line prettier/prettier
    let url = `${getRuntimeConfig('CMS_DISPATCHER_URL')}page/content/?pageType=STANDALONE&slug=${slug}&locale=${locale}&preview_mode=${isPreviewEnabled}`;

    // TODO After fix, delete this one
    url = `https://www.udemy.com/frontends-legal-terms/cms-dispatcher/page/content/?pageType=STANDALONE&slug=${slug}&locale=${locale}&preview_mode=${isPreviewEnabled}`;

    if (!isServer) {
        // We're adding app base pat so this can hit to frontends and we can rewrite the url to the correct path
        url = `/${process.env.APP_NAME}/cms-dispatcher/page/content/?pageType=STANDALONE&slug=${slug}&locale=${locale}&preview_mode=${isPreviewEnabled}`;
    }

    // eslint-disable-next-line no-console
    console.log(`The requested url ${url}, isServer: ${isServer}`);

    try {
        const response = await fetch(url, {
            method: 'GET',
            credentials: 'omit',
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data?.content?.[0];
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(
            `Error fetching cms data from cms-dispatcher with slug: ${slug} by using ${url} and locale: ${locale}. Error: ${JSON.stringify(
                e,
            )}`,
        );
        return {
            notFound: true,
        };
    }
};
